import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { useBranding } from "../contexts/BrandingContext";

/**
 * Sets `document.title` to the current organization's business name when
 * the user is logged in, falling back to the branded app name otherwise.
 *
 * Renders nothing visually — just a side effect manager mounted near the
 * root of the app so every route gets the correct tab title.
 */
export default function DocumentTitle() {
  const { user } = useAuth();
  const branding = useBranding();
  const [tenantName, setTenantName] = useState("");

  // Fetch the tenant name once per logged-in session.
  useEffect(() => {
    if (!user) { setTenantName(""); return; }
    let cancelled = false;
    api.get("/tenants/me")
      .then(r => { if (!cancelled) setTenantName(r.data?.business_name || ""); })
      .catch(() => { if (!cancelled) setTenantName(""); });
    return () => { cancelled = true; };
  }, [user]);

  useEffect(() => {
    const appName = branding.app_name || "SalonFlow";
    if (user && tenantName && tenantName !== appName) {
      document.title = `${tenantName} · ${appName}`;
    } else {
      document.title = appName;
    }
  }, [user, tenantName, branding.app_name]);

  return null;
}
